var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.label)?_c('span',{staticClass:"tag",class:_vm.color,attrs:{"title":_vm.title},domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }